import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/services.js";



const useStyles = makeStyles(styles);

export default function Services() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center" >
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.container}>
            <div className={classes.title}>
              <h2 className={classes.title}>سایر خدمات ما</h2>
              <br />
            </div>
          </div>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer justify="center" >
          <GridItem xs={6} sm={8} md={10}>
            <GridContainer justify="center" >
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_self' href='/Services/Tour'>
                  <img
                    src={"/assets/images/toranj.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>سامانه تور و نمایشگاه مجازی ترنج با پنل کاربری</h5>
                </a>
              </GridItem>
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_self' href='/Services/PenetrationTesting'>
                  <img
                    src={"/assets/images/counseling.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>مشاوره توسعه نرم‌افزار، امنیت و منابع انسانی</h5>
                </a>
              </GridItem>
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_self' href='/RoboCupSoccerSimulation'>
                  <img
                    src={"/assets/images/events.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>برگزاری رویدادهای فناوری</h5>
                </a>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
